import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { LoaderService } from '@shared/services/loader.service';
import { PaymentService } from '../../modules/payments/services/payment.service';
import { CardAdministrationService } from '@core/card-administration/services/card-administration.service';

@Injectable()
export class InjectAuthInterceptor implements HttpInterceptor {
  private requestCount = 0;
  constructor(
    private _paymentService: PaymentService,
    private _loaderService: LoaderService,
    private readonly _cardAdministrationService: CardAdministrationService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    try {
      this.requestCount++;
      let url = request.url;
      // IMPLEMENTACIÓN DE PAGINA DE CARGA
      this._loaderService.showLoading();
      if (
        url.includes('/payment/card-payment') ||
        url.includes('replace-bank-card')
      ) {
        const token = this._paymentService.getAuthToken();
        request = request.clone({
          setHeaders: {
            authorization: `Bearer ${token}`,
          },
        });
      } else if (url.includes('card-administration/save-bank-card')) {
        const token = this._cardAdministrationService.getAuthToken();
        request = request.clone({
          setHeaders: {
            authorization: `Bearer ${token}`,
          },
        });
      }

      return next.handle(request).pipe(
        finalize(() => {
          this.requestCount--;
          if (this.requestCount === 0 && !this._loaderService.isBlockLoading) {
            this._loaderService.hideLoading();
          }
        })
      );
    } catch (error) {
      return next.handle(request);
    }
  }
}
